import Icon from 'lqa-ui/lib/Components/Icon';
import React from 'react';
import ReactSlider from 'react-slider';

const StepSlider = ({ onAfterChange, onChange, currentIndex, max }) => {
  const min = 0;
  return (
    <ReactSlider
      className="horizontal-slider"
      marks={true}
      markClassName="example-mark"
      min={min}
      max={max}
      defaultValue={currentIndex}
      onChange={onChange}
      onAfterChange={onAfterChange}
      value={currentIndex}
      thumbClassName="example-thumb"
      trackClassName="example-track"
      renderMark={(props) => {
        if (props.key > currentIndex) {
          props.className = 'example-mark example-mark-completed';
        } else if (props.key === currentIndex) {
          props.className = 'example-mark example-mark-active';
        }
        if (props.key === 0) {
          props.className += ' example-mark-first';
        }
        if (props.key === max) {
          props.className += ' example-mark-last';
        }
        return <span {...props} />;
      }}
      renderThumb={(props, state) => {
        return(
          <div {...props}>
            <span className="pr-2">
              <Icon width={10} height={10} kind="arrow-left" />
            </span>
            <span className={'dot-4FADA6'} />
            <span className="pl-2" >
              <Icon width={10} height={10} kind="arrow-right" />
            </span>
          </div>
        );
      }
    }
    />
  );
};

export default StepSlider;
